"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const logo_360_oficial_webp_1 = __importDefault(require("../../../assets/images/logo_360_oficial.webp"));
const underline_1 = __importDefault(require("../../../components/underline"));
require("./NoAvailableSuitesStyles.scss");
const NoAvailableSuites = ({ buildingName, requestError }) => {
    const getStringContent = {
        anyWithDate: (react_1.default.createElement("span", null, "Opss... N\u00E3o h\u00E1 edif\u00EDcios com su\u00EDtes dispon\u00EDveis para data selecionada. Mas temos algumas sugest\u00F5es:")),
        anyWithoutDate: react_1.default.createElement("span", null, "Opss... N\u00E3o h\u00E1 edif\u00EDcios com su\u00EDtes dispon\u00EDveis. Mas temos algumas sugest\u00F5es:"),
        buildingWithoutDate: (react_1.default.createElement("span", null,
            `Opss... o Edifício `,
            " ",
            react_1.default.createElement("strong", null, `${buildingName || 'selecionado'}`),
            "        ",
            ' ',
            ` não tem nenhuma suíte disponível. Mas temos algumas sugestões:`)),
        someWithoutDate: (react_1.default.createElement("span", null, "Opss... os Edif\u00EDcio selecionados n\u00E3o possuem nenhuma su\u00EDte dispon\u00EDvel. Mas temos algumas sugest\u00F5es:")),
        someWithDate: (react_1.default.createElement("span", null, `Opss... os Edifício selecionados não possuem nenhuma suíte disponível para a data selecionada. Mas temos algumas sugestões: `)),
        default: (react_1.default.createElement("span", null,
            `Opss... o Edifício `,
            react_1.default.createElement("strong", null, `${buildingName || 'selecionado'}`),
            ` não tem nenhuma suíte disponível para a data selecionada. Mas temos algumas sugestões:`)),
        get getString() {
            return (this === null || this === void 0 ? void 0 : this[buildingName]) || (!!buildingName && (this === null || this === void 0 ? void 0 : this.default));
        },
    };
    return (react_1.default.createElement("div", { className: "NoAvailableSuites" },
        react_1.default.createElement("img", { src: logo_360_oficial_webp_1.default, alt: "logo" }),
        react_1.default.createElement(underline_1.default, { style: { height: '15px', width: '130px' } }),
        getStringContent.getString,
        requestError && react_1.default.createElement("span", null, "Ooops... Estamos com problemas para trazer as su\u00EDtes dispon\u00EDveis")));
};
exports.default = NoAvailableSuites;
